import { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await authAPI.getMe();
        setUser(response.data);
      } catch (error) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const response = await authAPI.login({ email, password });
    const { token, user } = response.data;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  // Supports both new (module, action) and legacy (permName) signatures
  const hasPermission = (moduleOrName, action) => {
    if (!user) return false;
    if (user.role === 'admin') return true;
    const perms = user.permissions || {};
    if (action) {
      const modPerms = perms[moduleOrName];
      if (modPerms && typeof modPerms === 'object') return !!modPerms[action];
      return false;
    }
    // legacy: {perm: bool}
    return perms[moduleOrName] === true;
  };

  const canViewModule = (moduleName) => {
    if (!user) return false;
    if (user.role === 'admin') return true;
    const perms = user.permissions || {};
    const modPerms = perms[moduleName];
    if (modPerms && typeof modPerms === 'object') return !!modPerms.view;
    return false;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, hasPermission, canViewModule, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within an AuthProvider');
  return context;
};
